var map = {
	"./ANYMARKET_LOGO.png": "3546",
	"./CONSIGNET_LOGO.png": "5127",
	"./DB1GLOBAL_LOGO.png": "b4f5",
	"./DB1GROUP_LOGO.png": "e559",
	"./DB1_LOGO.png": "83a4",
	"./DUCZ_LOGO.png": "df38",
	"./GILEADE_LOGO.png": "5d57",
	"./KONCILI_LOGO.png": "f7a9",
	"./LABS_LOGO.png": "13ba",
	"./LUGHY_LOGO.png": "277b",
	"./MIXTRA_LOGO.png": "1914",
	"./PREDIZE_LOGO.png": "37f0",
	"./TINBOT_LOGO.png": "0c63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d931";